import abi from'./Transaction.json';

export const contractABI=abi.abi;

// YOUR CONTRACT ADDRESS
export const contractAddress= process.env.REACT_APP_CONTRACT_ADDRESS;